export const COLORS = {
  BLUE: "#3E90CE",
  GREEN: "#9CC23B",
  YELLOW: "#E8AB1D",
  PINK: "#E0215D",
  FONT: "#3E5666",
  WHITE: "#FFFFFF",
  TITLE: "#3E90CE"
}
